import { TalentScore } from '@/Models/TalentScore';

function isFullReportDownloadDisabled(talentScore?: TalentScore | null): boolean {
    // TalentScore is only available when both tests are completed and average experience criteria score is calculated
    // We only allow to download report when all scores are in place.
    return talentScore === undefined || talentScore === null;
}

export default isFullReportDownloadDisabled;
